"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MonitoringService = void 0;
const browser_rum_1 = require("@datadog/browser-rum");
//TODO: extend unit tests to include clientTracking
exports.MonitoringService = {
    clientTracking: {},
    initFromClient(args) {
        this.clientTracking = Object.assign({}, args);
    },
    init({ envName, serviceName, version, sampleRate, applicationId, clientToken, useCrossSiteSessionCookie = false, }) {
        if (!applicationId || !clientToken) {
            return;
        }
        browser_rum_1.datadogRum.init({
            applicationId,
            clientToken,
            site: 'datadoghq.eu',
            service: serviceName,
            env: envName,
            version,
            sampleRate,
            useCrossSiteSessionCookie,
        });
    },
    trackError(error, errorMetadata, fingerprint) {
        if (!this.clientTracking.trackError) {
            return browser_rum_1.datadogRum.addError(error, fingerprint
                ? Object.assign({ 'error.fingerprint': fingerprint }, errorMetadata) : errorMetadata);
        }
        return this.clientTracking.trackError(error, errorMetadata);
    },
    addMonitorAction(name, context) {
        if (!this.clientTracking.addAction) {
            return browser_rum_1.datadogRum.addAction(name, context);
        }
        return this.clientTracking.addAction(name, context);
    },
    addMonitorTiming(timingVariable) {
        if (!this.clientTracking.addTiming) {
            return browser_rum_1.datadogRum.addTiming(timingVariable);
        }
        return this.clientTracking.addTiming(timingVariable);
    },
    addGlobalContext(key, context) {
        if (!this.clientTracking.addRumGlobalContext) {
            return browser_rum_1.datadogRum.addRumGlobalContext(key, context);
        }
        return browser_rum_1.datadogRum.addRumGlobalContext(key, context);
    },
    addTiming(timingName) {
        browser_rum_1.datadogRum.addTiming(timingName);
    },
};
//# sourceMappingURL=monitoring.service.js.map